import { render, staticRenderFns } from "./daka.vue?vue&type=template&id=75e34736"
import script from "./daka.vue?vue&type=script&lang=js"
export * from "./daka.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX\\qsx-web\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports